import debug from 'debug'
const warn = console.warn
// warn.log = console.warn.bind(console); 
// const error = console.error
// error.log = console.error.bind(console); 
export {warn}; 
